module.exports = __webpack_public_path__ + "CreativeDirection34.jpg?2ba1324058fb43e4ae427821068d4801";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection34.jpg
// module id = 47
// module chunks = 0